'use es6';

import noAuthClient from './clients/noAuthApiClient';
import { standardApi } from './middlewares/core';
var hubspot = standardApi('api', 'hubspot');

var refreshCookieForApi = function refreshCookieForApi(portalId, api, withNoCacheHeader) {
  var headers = {
    'X-Force-Cookie-Refresh': true
  };

  if (withNoCacheHeader) {
    headers['X-Force-Cookie-Refresh-No-Cache'] = true;
  }

  var query = portalId ? {
    portalId: portalId
  } : {};
  var path = "/login-api/v1/cookie-refresh" + (portalId ? '' : '/hubless');
  return noAuthClient.get(path, {
    api: api,
    headers: headers,
    withCredentials: true,
    query: query
  });
};

export var refreshCookie = function refreshCookie(portalId) {
  var withNoCacheHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return refreshCookieForApi(portalId, hubspot, withNoCacheHeader);
};